import termsConditionsContent from './content/terms-conditions.json';

const termsConditionsMock = {
    layoutType: 2,
    data: {
        name: 'terms-and-conditions',
        layoutType: 2,
        areasList: [
            {
                id: 'terms-conditions-page-area',
                name: 'Content',
                componentName: 'Comp:TermsConditionsPage',
                content: JSON.stringify(termsConditionsContent),
            },
        ],
    },
};

export default termsConditionsMock;
